import styles from "./GradientToggleButtons.module.scss";
import classNames from "classnames";
import { ReactNode } from "react";

type GradientToggleButtonsProps<T> = {
  className?: string;
  small?: boolean;
  selectedItemId: T;
  items: Array<{ id: T; value: ReactNode; disabled?: boolean }>;
  onItemClick: (id: T) => void;
};

export const GradientToggleButtons = <T,>({
  className,
  selectedItemId,
  items,
  onItemClick,
  small,
}: GradientToggleButtonsProps<T>) => {
  return (
    <div
      className={classNames(styles.container, className, {
        [styles.small]: small,
      })}
    >
      {items.map(({ id, disabled, value }) => {
        return (
          <div
            className={classNames(styles.item, {
              [styles.active]: selectedItemId === id,
              [styles.disabled]: disabled,
            })}
            onClick={() => !disabled && onItemClick(id)}
          >
            {value}
          </div>
        );
      })}
    </div>
  );
};
